import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { isMobile } from 'mobile-device-detect';
import VueRouter from 'vue-router';
import router from './router';
import { ModalPlugin}from "bootstrap-vue";
import VueCookies from 'vue-cookies';
import VueScrollTo from 'vue-scrollto';
import VueGtag from "vue-gtag";
import vuetify from './plugins/vuetify';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import HttpService from "./plugins/http.service";

Vue.use(Vuetify);

Vue.use(HttpService);

const opts = {}

export default new Vuetify(opts)


Vue.use(VueScrollTo);
Vue.use(ModalPlugin);
Vue.use(VueCookies);
Vue.use(VueRouter);
Vue.use(isMobile);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-173925017-1" },
  includes: [
    { id: 'UA-174030579-1' }
  ]
});


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
